import Snackbar from 'node-snackbar'

const searchParams = new URLSearchParams(window.location.search)
const contactPosted = searchParams.get('contact_posted')
if (contactPosted === 'true') {
  Snackbar.show({
    pos: 'bottom-center',
    showAction: false,
    text: 'Thank You for Submitting Your Request.  We`ve received your request and will respond to you as quickly as possible!',
    backgroundColor: '#6499C3'
  })
}
